import React from 'react';
import { DefaultButton, mergeStyleSets, Stack } from '@fluentui/react';
import { useNavigate, useLocation } from 'react-router-dom';
import Store from '../shared/state/Store';
import Routing from '../shared/Routing';

export const DefaultNavOption = Routing.getTree({}).home.routes.account.routes.subscription.path;

const styles = mergeStyleSets({
  menuItem: {
    textAlign: 'left',
    border: 'none !important',
    selectors: {
      ':hover': {
        outline: 'none !important',
        backgroundColor: '#e4e4e4',
      },

      span: {
        fontWeight: 'normal !important',
      },
    },
  },

  menuItemSelected: {
    backgroundColor: '#e4e4e4',
  },
});

export default () => {
  const [globalState] = Store.useStore();
  const navigate = useNavigate();
  const location = useLocation();
  const routingTree = Routing.getTree(globalState).home.routes.account.routes;

  const menuItems = [
    {
      type: 'button',
      text: routingTree.subscription.text,
      key: routingTree.subscription.path,
      action: () => navigate(routingTree.subscription.path),
    },
    {
      type: 'button',
      text: routingTree.licenseKeys.text,
      key: routingTree.licenseKeys.path,
      action: () => navigate(routingTree.licenseKeys.path),
    },
  ];

  const selectedMenuItem = location.pathname || DefaultNavOption;

  const renderedItems = menuItems.map(((menuItemData) => {
    let className = styles.menuItem;
    if (menuItemData.key === selectedMenuItem) {
      className += ` ${styles.menuItemSelected}`;
    }
    return (
      <DefaultButton
        key={menuItemData.key}
        text={menuItemData.text}
        className={className}
        onClick={(event) => {
          menuItemData.action();
          event.target.closest('button').blur();
        }}
      />
    );
  }));

  return (
    <Stack vertical>
      {renderedItems}
    </Stack>
  );
};
